export default __webpack_public_path__ + "static/media/out_of_stock.05352537.svg";